<form [formGroup]="userForm" (ngSubmit)="onSubmit()" class="container user-form" novalidate>
    <div class="form-row" *ngIf="!isModal">
        <div class="col-12">
            <hr />
            <h2 class="h4 primary-1">
                <span>{{ 'community.nav.members.userProfile' | translate }}</span>
            </h2>
        </div>
    </div>

    <div class="form-row">
        <div class="col-md-6 col-sm-12 mt-2">
            <label for="user_email">{{ 'user.personalInfo.email' | translate }}*</label>
            <input
                type="text"
                class="form-control"
                [ngClass]="{
                    'red-border': isFieldValid('email')
                }"
                id="user_email"
                formControlName="email"
                aria-describedby="userEmail"
                placeholder="{{ 'user.personalInfo.email' | translate }}"
                (blur)="onEmailBlur()"
                [attr.disabled]="isReadOnlyMode ? true : null"
            />
        </div>
        <div class="col-md-6">
            <span class="email-info">
                {{ 'community.nav.members.emailInfo' | translate }}
            </span>
            
        </div>
        <div class="col-md-6 col-sm-12 mt-2">
            <label for="lastName">{{ 'user.personalInfo.lastname' | translate }}*</label>
            <input
                class="form-control"
                [ngClass]="{
                    'red-border': isFieldValid('lastName')
                }"
                type="text"
                name="lastName"
                id="lastName"
                formControlName="lastName"
                aria-describedby="userName"
                placeholder="{{ 'user.personalInfo.lastname' | translate }}"
                [attr.disabled]="isReadOnlyMode ? true : null"
            />
        </div>
        <div class="col-md-6 col-sm-12 mt-2">
            <label for="firstName">{{ 'user.personalInfo.firstname' | translate }}*</label>
            <input
                class="form-control"
                [ngClass]="{
                    'red-border': isFieldValid('firstName')
                }"
                name="firstName"
                id="firstName"
                type="text"
                formControlName="firstName"
                aria-describedby="userFirstname"
                placeholder="{{ 'user.personalInfo.firstname' | translate }}"
                [attr.disabled]="isReadOnlyMode ? true : null"
            />
        </div>
        <div class="col-md-6 col-sm-12 mt-2">
            <label for="organization">{{ 'administration.global.pages.users.addUser.organizationField' | translate }}*</label>
            <br />
            <p-autoComplete
                placeholder="{{ 'administration.global.pages.users.addUser.organizationField' | translate }}"
                formControlName="organizationFromInput"
                [suggestions]="availableOrganizations"
                (completeMethod)="filterOrganizations($event)"
                field="name"
                minLength="3"
                styleClass="d-block w-100"
                inputStyleClass="form-control"
                [disabled]="isReadOnlyMode"
            ></p-autoComplete>
        </div>
        <div class="col-md-6 col-sm-12 mt-2">
            <label for="organizationRoles">{{ 'community.nav.members.organizationRole' | translate }}</label>
            <div class="d-flex align-items-center" style="height: 50%">
                <input
                    type="checkbox"
                    class="p-checkbox"
                    id="isOrganizationManager"
                    formControlName="isOrganizationManager"
                    [attr.disabled]="isReadOnlyMode ? true : null"
                />
                <span class="ml-2">{{ 'community.nav.members.organizationManager' | translate }}</span>
                <i class="ml-2 pi pi-question-circle" pTooltip="{{ 'community.nav.members.organizationManagerTooltip' | translate }}" tooltipPosition="right"></i>
            </div>
        </div>
        <div class="col-md-6 col-sm-12 mt-2">
            <label for="communities">{{ 'filters.shared.communitiesFilters' | translate }}*</label>
            <ng-select
                autocomplete="off"
                [items]="availableCommunities"
                bindLabel="displayName"
                bindValue="id"
                labelForId="communities"
                [multiple]="true"
                [hideSelected]="true"
                placeholder="{{ 'filters.shared.communitiesFilters' | translate }}"
                clearAllText="Supprimer toutes les communautés"
                [closeOnSelect]="false"
                formControlName="communitiesIds"
                [searchable]="false"
            >
            </ng-select>
        </div>
        <div class="col-md-6 col-sm-12 mt-2" [ngClass]="{ 'd-none': isReadOnlyMode }">
            <label for="primaryCommunity">{{ 'community.nav.members.primaryCommunity' | translate }}*</label>
            <ng-select
                autocomplete="off"
                [hideSelected]="true"
                notFoundText="Aucune communauté sélectionnée"
                placeholder="{{ 'community.nav.members.primaryCommunity' | translate }}"
                labelForId="primaryCommunity"
                formControlName="primaryCommunityId"
                [searchable]="false"
            >
                <ng-option *ngFor="let selectedCommunity of selectedCommunities" [value]="selectedCommunity.id">
                    {{ selectedCommunity.displayName }}
                </ng-option>
            </ng-select>
        </div>
    </div>
    <div class="form-row mt-2">
        <div class="col col-auto ml-auto">
            <button class="btn btn-secondary ml-1" (click)="onCancel()">
                <em class="pi pi-times d-sm-inline d-md-none"></em>
                <span class="d-none d-sm-inline">{{ 'components.button.buttonCancel' | translate }}</span>
            </button>
            <button class="btn btn-primary ml-1" [disabled]="userForm.invalid">
                <em class="pi pi-save d-sm-inline d-md-none"></em>
                <span class="d-none d-sm-inline">{{ 'components.button.buttonValidation' | translate }}</span>
            </button>
        </div>
    </div>
</form>
